import type {FC, ReactNode} from 'react';

import type {Variant} from '../ToolBoxButton/types';
import type {Size} from './types';

import ArrowRight from '../../assets/icons/secondary/Arrow - Right 2.svg';
import {Icon} from '../../uikit/Icon';
import {Text} from '../../uikit/Text';
import {getTitle} from '../ToolBoxButton/utils';
import {ToolboxIcon} from '../ToolboxIcon';
import * as S from './styles';
import {getDescription} from './utils';

type Props = {
  onClick?: () => void;
  renderActions?: () => ReactNode;
  size?: Size;
  variant: Variant;
};

export const ToolboxBanner: FC<Props> = ({
  onClick,
  renderActions,
  size = 'me',
  variant,
}) => {
  return (
    <S.Container
      isClickable={Boolean(onClick)}
      onClick={onClick}
      size={size}
      variant={variant}
    >
      <ToolboxIcon variant={variant} />
      <S.Content>
        <Text color="text.white" variant="h2">
          {getTitle(variant)}
        </Text>
        {size === 'me' ? (
          <Text color="text.white">{getDescription(variant)}</Text>
        ) : null}
      </S.Content>
      {renderActions?.()}
      {onClick ? (
        <S.BannerButton onClick={onClick}>
          <Icon color="icon.white" svg={ArrowRight} />
        </S.BannerButton>
      ) : null}
    </S.Container>
  );
};
